import { Modal, Row, Space } from "antd";
import React, { useState } from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import FanStatusTag from "./Tags/FanStatusTag";
import AugerStatusTag from "./Tags/AugerStatusTag";
import MachineStatusTag from "./Tags/MachineStatusTag";
import BurnerStatusTag from "./Tags/BurnerStatusTag";
import CO2StatusTag from "./Tags/CO2StatusTag";

interface HeaderProps {
    binDto: PremierPlusBinDTO | null;  
    rightSideItems?: React.ReactNode[]; 
}

const Header : React.FC<HeaderProps> = ({ binDto, rightSideItems }) => {

    const headerStyle = {
        paddingTop: 0,
        paddingBottom: 4,
        borderBottom: `2px solid #d9d9d9`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '0px'
    }

    return(
        <Row gutter={2} wrap style={headerStyle}>
            <div style={{  display: 'flex',  flexDirection: 'row',  alignItems: 'center' }}>
                <FanStatusTag 
                fanState={binDto?.fans?.[0]} 
                fanOperationState={binDto?.fanRunOperation} 
                desiredFanSettings={binDto?.settings?.fanRunSettings}
                />

                <AugerStatusTag augers={binDto?.augers}/>

                <MachineStatusTag isMachineOn={binDto?.isMachineOn ?? false}/>

                <BurnerStatusTag fanState={binDto?.fans?.[0]}/>
            </div>
            <Space style={{ gap:'2px'}}>
                {
                    binDto?.gaMs?.length != 0 && 
                        <CO2StatusTag gaMs={binDto?.gaMs}/>
                }
                {rightSideItems?.map( (t) => t)} 
            </Space>
        </Row>
    )
}

export default Header;